import { useEffect, useState } from 'react';

export const validateImageURL = (imageUrl: string): Promise<void> => {
  return new Promise((resolve, reject) => {
    const optionImage = new Image();
    optionImage.src = imageUrl;

    optionImage.onload = () => {
      resolve();
    };

    optionImage.onerror = () => {
      reject();
    };
  });
};

export const useValidateImage = (imageUrl?: string | null) => {
  const [loaded, setLoaded] = useState(false);
  const [isImageValid, setIsImageValid] = useState(false);

  useEffect(() => {
    if (!imageUrl) {
      return;
    }

    const checkImageValidation = async () => {
      try {
        await validateImageURL(imageUrl);
        setIsImageValid(true);
      } catch {
        setIsImageValid(false);
      } finally {
        setLoaded(true);
      }
    };
    checkImageValidation();
  }, []);

  return { loaded, isImageValid };
};
